// Users endpoints: /api/v1/admin/platform/users* (every account, across tenants).

import { apiFetch } from './client'
import type { PlatformUser, UserListParams, UserListResponse, UserPatch } from './types'

const BASE = '/admin/platform/users'

export function listUsers(params: UserListParams = {}, signal?: AbortSignal): Promise<UserListResponse> {
  return apiFetch(BASE, {
    query: { q: params.q?.trim() || undefined, kind: params.kind, league_id: params.league_id, sort: params.sort === 'email' ? undefined : params.sort, page: params.page, page_size: params.page_size },
    signal,
  })
}

export async function getUser(id: number, signal?: AbortSignal): Promise<PlatformUser> {
  const r = await apiFetch<{ user: PlatformUser }>(`${BASE}/${id}`, { signal })
  return r.user
}

/**
 * PATCH /platform/users/:id. The server refuses changing your own
 * platform_role / is_active (403 forbidden) and removing the last active
 * super-admin (409 last_super_admin); the UI mirrors both rules.
 */
export async function updateUser(id: number, patch: UserPatch): Promise<PlatformUser> {
  const r = await apiFetch<{ user: PlatformUser }>(`${BASE}/${id}`, { method: 'PATCH', body: patch })
  return r.user
}
